(function ($, ajax_options) {
	$('.js-customers-pagination').on(
		'click',
		'.js-customers-load-more',
		function () {
			var postsContainer = $('.js-customers-posts'),
				paginationContainer = $('.js-customers-pagination'),
				paginationWrap = paginationContainer.closest('.pagination'),
				button = $(this),
				page = button.data('page'),
				postsPerPage = postsContainer.data('postsperpage'),
				outcomeFilter = postsContainer.attr('data-filter-outcome'),
				industryFilter = postsContainer.attr('data-filter-industry'),
				windowWidth =
					window.innerWidth ||
					document.documentElement.clientWidth ||
					document.body.clientWidth;

			if (windowWidth < 761) {
				postsPerPage = 3;
			}

			postsContainer.addClass('u-news--loading');
			paginationContainer.find('button').attr('disabled', 'disabled');

			$.ajax({
				url: ajax_options.admin_ajax_url,
				data: {
					action: 'customers_load_more',
					page: page,
					pagination: postsPerPage || '',
					outcometerms: outcomeFilter || '',
					industryterms: industryFilter || '',
				},
				method: 'post',
			})
				.then(function (data) {
					if (data.html) {
						$('.js-customers-posts').html(data.html);
						var pagesCount = data.pages_count;

						var pagination =
							'<button id="js-customers-update" class="js-customers-load-more" data-page="1"></button>';
						if (page > 1) {
							pagination +=
								'<button class="page-navigation prev js-customers-load-more" data-page="' +
								(page - 1) +
								'"></button>';
						}

						pagination += '<ul class="page-number">';

						var visiblePagesDistance;
						if (page === 1 || page === pagesCount) {
							visiblePagesDistance = 4;
						} else if (page === 2 || page === pagesCount - 1) {
							visiblePagesDistance = 3;
						} else visiblePagesDistance = 2;

						for (var i = 1; i <= pagesCount; i++) {
							if (i < page - visiblePagesDistance && i > 1) {
								pagination += '<li><span>...</span></li>';
								i = page - visiblePagesDistance - 1;
								continue;
							}

							if (i == page) {
								pagination +=
									'<li><span class="is-active" data-page="' +
									i +
									'">' +
									i +
									'</span></li>';
								continue;
							}

							if (
								i > page + visiblePagesDistance &&
								i < pagesCount
							) {
								pagination += '<li><span>...</span></li>';
								i = pagesCount - 1;
								continue;
							}

							pagination +=
								'<li><button class="js-customers-load-more" ' +
								'data-page="' +
								i +
								'">' +
								i +
								'</button>';
						}
						pagination += '</ul>';

						if (page < pagesCount) {
							pagination +=
								'<button class="page-navigation next js-customers-load-more" ' +
								'data-page="' +
								(page + 1) +
								'"></button>';
						}

						paginationContainer.html(pagination);
						if (paginationWrap.hasClass('pagination--hidden')) {
							paginationWrap.removeClass('pagination--hidden');
						}
						paginationContainer.parent().removeClass('');
						postsContainer.removeClass('u-news--loading');
						paginationContainer
							.find('button')
							.removeAttr('disabled');
					} else {
						$('.js-customers-posts').html('');
						paginationContainer.html(
							'<button id="js-customers-update" class="js-customers-load-more" data-page="1"></button>'
						);
						postsContainer.removeClass('u-news--loading');
						paginationContainer
							.find('button')
							.removeAttr('disabled');
					}
				})
				.catch(function () {
					$('.js-customers-posts').html('');
					paginationContainer.html(
						'<button id="js-customers-update" class="js-customers-load-more" data-page="1"></button>'
					);
					postsContainer.removeClass('u-news--loading');
					paginationContainer.find('button').removeAttr('disabled');
				});
			return false;
		}
	);

	$('#js-customers-update').click();

	// @ts-ignore-next
})(jQuery, ajax_options);
